<template>
  <div>
    <el-card
      class="mt10"
      v-for="item in tableData"
      :key="item.sortNum"
      :id="getPanelId(item.sortNum)"
    >
      <div slot="header" class="clearfix">
        <div v-if="isChange">
          变更申请
          <el-tag class="ml10">
            状态：
            <span v-text="item.stateName"></span>
          </el-tag>
          <el-tag class="ml10">
            <span>
              {{ moment(item.editTime).format('YYYY-MM-DD HH:mm:ss') }}
            </span>
          </el-tag>
        </div>
        <div v-else>
          抽取需求批次
          <span v-text="item.sortNum"></span>
          <el-tag class="ml10">
            状态：
            <el-button
              type="text"
              size="small"
              @click="handleLog(item.batchEid)"
            >
              <span v-text="item.stateName"></span>
            </el-button>
          </el-tag>
          <el-tag class="ml10">
            <span>
              {{ moment(item.editTime).format('YYYY-MM-DD HH:mm:ss') }}
            </span>
          </el-tag>
        </div>
      </div>
      <div>
        <div class="mt10" :id="getPanelId(item.sortNum, '-mavin')">
          <div v-if="isChange">
            <span v-text="item.reason"></span>
            <seled :batchEid="item.batchEid" ref="Seled"></seled>
          </div>
          <div v-else>
            <para :batchEid="item.batchEid" ref="Para"></para>
            <seled :batchEid="item.batchEid" ref="Seled"></seled>
          </div>
        </div>
      </div>
    </el-card>

    <oper-log ref="OperLog"></oper-log>
  </div>
</template>

<script>
import Para from './Para.vue';
import Seled from './Seled.vue';
import OperLog from '@/components/OperLog/Index.vue';

import { listBatch } from '@/api/gains/batch.js';

export default {
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  props: {
    isChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Para,
    Seled,
    OperLog
  },
  methods: {
    getPanelId(id, expand) {
      return 'pnl-batch' + id + (expand ? expand : '');
    },
    refreshData() {
      this.$refs.Seled[0].list();
    },
    handleLog(batchEid) {
      this.$refs.OperLog.show('GainBatch', batchEid);
    },
    search() {
      this.loading = true;
      listBatch(this.$route.params.gainEid, this.isChange, false).then(res => {
        this.loading = false;
        this.tableData = res;
      });
    }
  },
  created() {
    this.search();
  }
};
</script>

<style></style>
